import React, { useState, useEffect } from 'react';
import MCADashboard from './MCADashboard';
import LawModule from './LawModule';
import CompanyMaster from './CompanyMaster';
import Incorporation from './Incorporation';
import Registers from './Registers';
import Placeholder from './Placeholder';
import ResolutionMaster from './ResolutionMaster';
import EventFilings from './EventFilings';
import AnnualFilings from './AnnualFilings';
import LlpEfiling from './llp/LlpEfiling';
import LlpRegister from './llp/LlpRegister';

const NAV_GROUPS = [
  {
    group: 'Companies Act, 2013',
    items: [
      { id: 'dashboard', label: 'MCA Dashboard' },
      { id: 'companies', label: 'Company Master' },
      { id: 'incorporation', label: 'Incorporation' },
      { id: 'resolutions', label: 'Resolution Master' },
      { id: 'event-filings', label: 'Event Filings' },
      { id: 'annual-filings', label: 'Annual Filings' },
      { id: 'registers', label: 'Statutory Registers' },
      { id: 'calendar', label: 'Compliance Calendar' },
      { id: 'documents', label: 'MCA Documents' },
      { id: 'law', label: 'Law Library' },
      { id: 'settings', label: 'MCA Settings' },
    ],
  },
  {
    group: 'LLP e-Filing (LLP Act, 2008)',
    items: [
      { id: 'llp-efiling', label: 'LLP e-Filing' },
      { id: 'llp-register', label: 'LLP Register' },
    ],
  },
];

const NAV_ITEMS = NAV_GROUPS.flatMap(g => g.items);

const NAV_ICONS = {
  dashboard: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  companies: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>,
  incorporation: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>,
  resolutions: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>,
  'event-filings': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  'annual-filings': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  'llp-efiling': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15l2 2 4-4"/></svg>,
  'llp-register': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/><path d="M9 7h6"/></svg>,
  registers: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  calendar: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  documents: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
  settings: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  law: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
};

// ─── ChanakyaX Logo (same inline SVG used across the app) ────────────────
function ChanakyaXLogo({ mode = 'full', height = 30, darkMode = false }) {
  if (mode === 'icon') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="11000 0 4263 2800"
        height={height} style={{ display: 'block', width: 'auto' }} aria-label="ChanakyaX">
        <path fill="#FC5C0B" d="M13821.58 1767.69c29.82,-67.16 129.86,-166.84 176.62,-225.85l1265.19 -1541.84c-72.91,44.24 -958.38,861.93 -1046.05,951.47 -73.2,74.76 -133.38,130.95 -207.85,196.97 -115.46,102.34 -331.11,359.88 -403.04,398.54 -109.82,-138.98 -440.05,-452.63 -508.09,-566.8l-376.95 -0.81c27.87,74.49 129.25,154.75 180.19,212.36l525.64 573.92c-20.18,52.59 -238.08,304.7 -284.77,358.39 -89.85,103.32 -827.29,975.23 -858.4,1042.22l894.31 -685.24c166.19,-124.82 334.53,-406.43 445.38,-488.22 108.99,111.67 205.94,209.69 294.46,317.91 102.93,125.84 97.41,114.34 193.31,113.42 96.42,-0.92 210.43,3.99 304.07,-3.75 -32.27,-73.18 -545.13,-557.76 -594.04,-652.69z"/>
      </svg>
    );
  }
  const wordmarkColor = darkMode ? '#f1f5f9' : '#02124E';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15263.4 3560.32"
      height={height} style={{ display: 'block', width: 'auto', maxWidth: 172 }} aria-label="ChanakyaX">
      <g>
        <path fill="#FC5C0B" d="M13821.58 1767.69c29.82,-67.16 129.86,-166.84 176.62,-225.85l1265.19 -1541.84c-72.91,44.24 -958.38,861.93 -1046.05,951.47 -73.2,74.76 -133.38,130.95 -207.85,196.97 -115.46,102.34 -331.11,359.88 -403.04,398.54 -109.82,-138.98 -440.05,-452.63 -508.09,-566.8l-376.95 -0.81c27.87,74.49 129.25,154.75 180.19,212.36l525.64 573.92c-20.18,52.59 -238.08,304.7 -284.77,358.39 -89.85,103.32 -827.29,975.23 -858.4,1042.22l894.31 -685.24c166.19,-124.82 334.53,-406.43 445.38,-488.22 108.99,111.67 205.94,209.69 294.46,317.91 102.93,125.84 97.41,114.34 193.31,113.42 96.42,-0.92 210.43,3.99 304.07,-3.75 -32.27,-73.18 -545.13,-557.76 -594.04,-652.69z"/>
        <path fill={wordmarkColor} d="M6267.05 2408.83l259.02 7.13 -3.47 -1277.96 -239.85 1.58 -8.4 890.95 -16.86 -19.07c-74.72,-55.17 -653.64,-655.92 -762.6,-768.93 -138.86,-144.03 -123.9,-147.95 -369.32,-128.47l5.46 1302.11c68.73,3.49 191.77,16.85 241.05,-9.12 32.6,-60.92 12.59,-741.84 10.3,-872.68l884.66 874.46z"/>
        <polygon fill={wordmarkColor} points="1973.31,1919.85 2787.18,1919.55 2789.06,2417.2 3052.41,2415.02 3052.05,1125.45 2788.64,1125.1 2782.22,1675.03 1971.99,1674.38 1969.16,1123.99 1708.58,1129.82 1712.66,2417.23 1970.19,2417.72"/>
        <path fill={wordmarkColor} d="M1350.08 1370.5c28.93,-41.1 106.82,-185.93 122.92,-246.2 -246.97,4.69 -809.94,-30.26 -1011.86,29.08 -586.87,172.47 -617.64,1004.21 -69,1213.44 207.71,79.21 701.49,56.65 959.06,51.46l115.82 -245.71c-258.8,-0.16 -524.78,4.7 -782.73,-1.19 -226.75,-5.18 -396.19,-136.09 -410.93,-350.47 -39.9,-580.06 603.74,-444.05 1076.71,-450.4z"/>
        <path fill={wordmarkColor} d="M7553.12 1462.41c83.47,89.42 489.4,901.38 543.34,959.24l303.59 -3.29c-22.67,-76.7 -325.16,-570 -389.75,-689.65 -67.82,-125.63 -128.68,-229.39 -196.06,-348.27 -111.53,-196.8 -123.17,-271.27 -261.57,-267.55 -128.5,3.45 -143.29,92.16 -255.3,288.54 -67.31,118.01 -127.22,221.6 -193.69,336.86 -57.14,99.08 -363.56,612.02 -382.04,678.56l295.5 0.76 535.98 -955.19z"/>
        <path fill={wordmarkColor} d="M11127.33 2419.38c307.64,0.45 285.66,31 349.1,-91.64 52.53,-101.57 447.59,-816.68 486.36,-857.52 2.39,2.67 5.45,6.42 6.89,8.26l263.55 464.85c88.71,159.81 172.38,318.09 260.87,477.95l311.25 1.16c-31.87,-100.64 -139.79,-252.36 -194.3,-353.77l-391.74 -683.03c-112.09,-189.45 -115.2,-272.65 -256.09,-269.11 -125.13,3.14 -151.35,110.39 -254.62,285.46l-394.12 680.47c-44.51,75.8 -168.52,269.27 -187.15,336.93z"/>
        <path fill={wordmarkColor} d="M3557.75 2417.64c62.19,-70.09 444.98,-834.11 543.16,-953.52 94.01,159.02 179.06,321.57 269.7,483.62l264.31 472.35 300.47 -3.46c-29.48,-85.74 -136.68,-253.64 -188.52,-341.7l-390.84 -683.98c-103.58,-172.88 -115.74,-274.6 -251.48,-275.12 -108.04,-0.42 -119.9,31.11 -165.28,110.37 -114.63,200.17 -662.8,1132.3 -670.68,1191.01l289.16 0.44z"/>
        <path fill={wordmarkColor} d="M10842.51 2074.77c-0.04,-97.1 -14.37,-112.55 36.47,-176.79 79.76,-100.78 596.47,-735.04 608.4,-773.2l-311.54 0.68 -463.6 594.6 -461.09 -595.7 -314.62 -1.81 184.17 239.83c66.21,84.11 117,143.75 178.86,225.86 58.35,77.43 123.48,160.78 183.7,235.15 106.16,131.1 93.25,91.15 93.24,307.19l3.43 291.02 261.89 -4.17 0.66 -342.68z"/>
        <path fill={wordmarkColor} d="M8601.33 2423.64l259.43 -8.84 -0.03 -649c46.99,18.06 178.25,162.93 228.46,209.5l441.53 423.84c62.04,43.21 304.78,15.89 404.37,18.81l-541.56 -509.63c-50.14,-42.1 -142.36,-121.85 -179.64,-168.55 94.49,-110.09 606.98,-577.77 636.47,-624.86 -109.55,-8.78 -302.21,-27.01 -369.2,27.67 -139.93,114.23 -515.97,533.52 -619.31,595.98l-2.18 -626.4 -258.97 -0.43 0.63 1311.9z"/>
        <path fill="#F55C0C" d="M11809.25 2410.22c60.65,-79 85.99,-178.99 158.61,-238.89l131.75 243.68 134.65 -1.31c-20.99,-85.95 -95.34,-194.38 -132.9,-267.72 -28.92,-56.48 -96.86,-198.76 -138.57,-237.54 -43.16,54.49 -264.73,429.43 -284.18,507.24l130.64 -5.46z"/>
        <path fill="#FC610C" d="M3811.99 2412.45c147.13,8.7 122.98,19.87 182.24,-85.1 25.23,-44.7 62.35,-112.63 96.31,-154.19 40.97,26.47 128.95,203.5 145.35,242.85l141.64 -6.22 -269.27 -505.88c-47.55,31.35 -274.79,441.19 -296.26,508.53z"/>
        <path fill="#FC610C" d="M7416.67 2412.85c29.25,-68.43 99.16,-199.87 148.68,-240.16l140.32 242.37 126.98 -3.07c-45.56,-153.06 -203.91,-355.47 -264.24,-507.7l-15.79 15.2c-52.55,64.07 -130.35,186.84 -136.32,265.55l136.81 -0.95z" opacity="0.9"/>
        <path fill="#F8640A" d="M7312.89 3528.64c117.06,71.38 207.47,-28.14 142.27,-114.42 -44.93,-59.46 -185.39,-40.92 -142.27,114.42z"/>
      </g>
    </svg>
  );
}

function MCA({ embedded = false, darkMode: darkModeProp, setDarkMode: setDarkModeProp, onClose }) {
  const [activePage, setActivePage] = useState('dashboard');
  const [navIntent, setNavIntent] = useState(null);

  const handleNavigate = (pageId, params) => {
    setNavIntent(params || null);
    setActivePage(pageId);
  };
  const [sidebarPinned, setSidebarPinned] = useState(false);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const sidebarOpen = sidebarPinned || sidebarHovered;
  const [internalDarkMode, setInternalDarkMode] = useState(() => localStorage.getItem('cx-theme') === 'dark');
  const darkMode = embedded && darkModeProp !== undefined ? darkModeProp : internalDarkMode;
  const setDarkMode = embedded && setDarkModeProp ? setDarkModeProp : setInternalDarkMode;

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userInitial = (user.full_name || user.name || user.email || 'U').charAt(0).toUpperCase();
  const userName = user.full_name || user.name || 'User';

  useEffect(() => {
    localStorage.setItem('cx-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  // ── Theme tokens — identical structure to main Dashboard.js ──────────────
  const T = darkMode ? {
    bg:           '#0f172a',
    bg2:          '#1e293b',
    bg3:          '#334155',
    border:       '#334155',
    border2:      '#475569',
    text:         '#f1f5f9',
    text2:        '#94a3b8',
    text3:        '#64748b',
    cardBg:       '#1e293b',
    cardBorder:   '#334155',
    sidebarBg:    '#0f172a',
    sidebarBorder:'#1e293b',
    topbarBg:     '#0f172a',
    topbarBorder: '#1e293b',
    hoverBg:      'rgba(249,115,22,0.12)',
    hoverColor:   '#f97316',
    activeBg:     'rgba(249,115,22,0.15)',
    activeColor:  '#f97316',
    navLabel:     '#475569',
  } : {
    bg:           '#f1f5f9',
    bg2:          '#fff',
    bg3:          '#f8faff',
    border:       '#e8edf5',
    border2:      '#e2e8f0',
    text:         '#0f1f45',
    text2:        '#4a5568',
    text3:        '#94a3b8',
    cardBg:       '#fff',
    cardBorder:   '#f1f5f9',
    sidebarBg:    '#ffffff',
    sidebarBorder:'#e8edf5',
    topbarBg:     '#ffffff',
    topbarBorder: '#e8edf5',
    hoverBg:      'linear-gradient(135deg,#fff5eb,#ffeedd)',
    hoverColor:   '#e8620a',
    activeBg:     'linear-gradient(135deg,#fff5eb,#ffeedd)',
    activeColor:  '#e8620a',
    navLabel:     '#a0aec0',
  };

  const renderContent = () => {
    switch (activePage) {
      case 'companies':
        return <CompanyMaster onNavigate={handleNavigate} />;
      case 'incorporation':
        return <Incorporation onNavigate={handleNavigate} />;
      case 'resolutions':
        return <ResolutionMaster />;
      case 'event-filings':
        return <EventFilings onNavigate={handleNavigate} initialCaseId={navIntent?.caseId} />;
      case 'annual-filings':
        return <AnnualFilings onNavigate={handleNavigate} initialCaseId={navIntent?.caseId} />;
      case 'llp-efiling':
        return <LlpEfiling onNavigate={handleNavigate} initialCaseId={navIntent?.caseId} />;
      case 'llp-register':
        return <LlpRegister />;
      case 'registers':
        return <Registers initialRegisterId={navIntent?.registerId} initialCompanyId={navIntent?.companyId} />;
      case 'calendar':
        return <Placeholder title="Compliance Calendar" desc="Auto due dates, reminders, filing deadlines and overdue compliance alerts will appear here." />;
      case 'documents':
        return <Placeholder title="MCA Documents" desc="Filed forms, challans, SRNs, resolutions, MOA, AOA, certificates and approval letters stored company-wise." />;
      case 'law':
        return <LawModule />;
      case 'settings':
        return <Placeholder title="MCA Settings" desc="Configure MCA services, workflows, checklist templates, resolution formats and due date rules." />;
      default:
        return <MCADashboard onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className={darkMode ? 'dark' : ''} style={{ position: 'relative', height: embedded ? '100%' : undefined, minHeight: embedded ? undefined : '100vh', display: 'flex', background: T.bg, transition: 'background 0.2s' }}>

      {/* ── SIDEBAR — light, matches main Dashboard exactly ── */}
      <aside
        onMouseEnter={() => setSidebarHovered(true)}
        onMouseLeave={() => setSidebarHovered(false)}
        style={{
          width: sidebarOpen ? '220px' : '64px',
          height: embedded ? '100%' : '100vh',
          minHeight: embedded ? undefined : '100vh',
          background: T.sidebarBg,
          borderRight: `1px solid ${T.sidebarBorder}`,
          position: embedded ? 'absolute' : 'fixed',
          left: 0,
          top: 0,
          zIndex: 40,
          transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1), background 0.2s',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Logo */}
        <div style={{
          padding: '18px 16px',
          borderBottom: `1px solid ${T.sidebarBorder}`,
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          minHeight: '60px',
          overflow: 'hidden',
          flexShrink: 0,
        }}>
          {sidebarOpen ? (
            <ChanakyaXLogo mode="full" height={22} darkMode={darkMode} />
          ) : (
            <ChanakyaXLogo mode="icon" height={22} />
          )}
        </div>

        {/* Module label */}
        <div style={{ padding: sidebarOpen ? '12px 16px 4px' : '12px 0 4px', overflow: 'hidden' }}>
          <p style={{
            fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase',
            color: T.navLabel, opacity: sidebarOpen ? 1 : 0, whiteSpace: 'nowrap',
            textAlign: sidebarOpen ? 'left' : 'center',
          }}>
            {sidebarOpen ? 'MCA Workspace' : ''}
          </p>
        </div>

        {/* Nav Items */}
        <style>{`.mca-nav-noscroll { scrollbar-width: none; -ms-overflow-style: none; } .mca-nav-noscroll::-webkit-scrollbar { display: none; width: 0; height: 0; }`}</style>
        <nav className="mca-nav-noscroll" style={{ flex: 1, padding: '4px 10px', overflowY: 'auto', overflowX: 'hidden' }}>
          {NAV_GROUPS.map((grp, gi) => (
          <div key={grp.group} style={{ marginTop: gi === 0 ? 0 : 12 }}>
            {gi > 0 && (
              <p style={{
                fontSize: 9.5, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase',
                color: T.navLabel, padding: sidebarOpen ? '4px 10px 6px' : '4px 0 6px',
                whiteSpace: 'nowrap', textAlign: sidebarOpen ? 'left' : 'center',
                borderTop: `1px solid ${T.sidebarBorder}`, marginTop: 4,
              }}>
                {sidebarOpen ? grp.group : '— · —'}
              </p>
            )}
          {grp.items.map(item => {
            const isActive = activePage === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setActivePage(item.id)}
                title={!sidebarOpen ? item.label : ''}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '9px 10px',
                  borderRadius: '10px',
                  marginBottom: '2px',
                  cursor: 'pointer',
                  border: 'none',
                  background: isActive ? T.activeBg : 'transparent',
                  color: isActive ? T.activeColor : T.text2,
                  fontWeight: isActive ? 700 : 500,
                  transition: 'all 0.15s',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textAlign: 'left',
                }}
                onMouseEnter={e => {
                  if (!isActive) {
                    e.currentTarget.style.background = T.hoverBg;
                    e.currentTarget.style.color = T.hoverColor;
                  }
                }}
                onMouseLeave={e => {
                  if (!isActive) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = T.text2;
                  }
                }}
              >
                <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                  {NAV_ICONS[item.id]}
                </span>
                <span style={{
                  fontSize: '12.5px',
                  opacity: sidebarOpen ? 1 : 0,
                  transition: 'opacity 0.15s',
                  overflow: 'hidden',
                }}>
                  {item.label}
                </span>
              </button>
            );
          })}
          </div>
          ))}
        </nav>

        {/* Pin toggle */}
        <div style={{ padding: '8px 10px', borderTop: `1px solid ${T.sidebarBorder}` }}>
          <button
            onClick={() => setSidebarPinned(v => !v)}
            title={sidebarPinned ? 'Unpin sidebar' : 'Pin sidebar'}
            style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 10px', borderRadius: 10, border: 'none',
              background: 'transparent', color: T.text3, cursor: 'pointer',
              fontSize: 12, fontWeight: 500,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill={sidebarPinned ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.8" style={{ flexShrink: 0 }}>
              <path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/>
            </svg>
            <span style={{ opacity: sidebarOpen ? 1 : 0, whiteSpace: 'nowrap' }}>{sidebarPinned ? 'Unpin sidebar' : 'Pin sidebar'}</span>
          </button>
        </div>

        {/* User Footer */}
        <div style={{
          padding: '12px 14px',
          borderTop: `1px solid ${T.sidebarBorder}`,
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          overflow: 'hidden',
          flexShrink: 0,
        }}>
          <div style={{
            width: '32px', height: '32px',
            borderRadius: '9px',
            background: 'linear-gradient(135deg, #1d3461, #1f6feb)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '13px', fontWeight: 700, color: 'white',
            flexShrink: 0,
          }}>
            {userInitial}
          </div>
          <div style={{
            opacity: sidebarOpen ? 1 : 0,
            transition: 'opacity 0.15s',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}>
            <p style={{ fontSize: '12px', fontWeight: 600, color: T.text }}>{userName}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#22c55e' }} />
              <p style={{ fontSize: '10px', color: T.text3 }}>Online</p>
            </div>
          </div>
        </div>
      </aside>

      {/* ── MAIN ── */}
      <main style={{
        marginLeft: sidebarOpen ? '220px' : '64px',
        flex: 1,
        minHeight: embedded ? undefined : '100vh',
        height: embedded ? '100%' : undefined,
        overflowY: embedded ? 'auto' : undefined,
        transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex',
        flexDirection: 'column',
      }}>

        {/* Header */}
        <header style={{
          height: '56px',
          background: T.topbarBg,
          borderBottom: `1px solid ${T.topbarBorder}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 24px',
          position: 'sticky',
          top: 0,
          zIndex: 20,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '3px', height: '18px', borderRadius: '2px', background: 'linear-gradient(180deg, #00206E, #FC5C0B)' }} />
            <h2 style={{ fontSize: '14px', fontWeight: 700, color: T.text }}>
              {NAV_ITEMS.find(i => i.id === activePage)?.label || 'MCA Dashboard'}
            </h2>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {/* Dark mode toggle — identical pattern to main Dashboard (Workspace shell owns this when embedded) */}
            {!embedded && (
            <button
              onClick={() => setDarkMode(v => !v)}
              title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
              style={{
                width: 34, height: 34, borderRadius: 9,
                border: `1px solid ${T.border2}`,
                background: T.bg3,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', color: T.text2,
              }}
            >
              {darkMode ? (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                  <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                </svg>
              ) : (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                </svg>
              )}
            </button>
            )}

            {!embedded && (
            <button
              onClick={() => onClose ? onClose() : window.close()}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                padding: '7px 14px',
                borderRadius: '9px',
                border: `1px solid ${T.border2}`,
                background: T.bg2,
                color: T.text2,
                fontSize: '12px',
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
              Close
            </button>
            )}
          </div>
        </header>

        <div style={{ padding: '20px', flex: 1 }}>
          {renderContent()}
        </div>
      </main>
    </div>
  );
}

export default MCA;